// extracted by mini-css-extract-plugin
export default {"player-container":"AVCEjs","playerContainer":"AVCEjs","poster":"qkC5BG","hide":"ErGSQi"};